module.exports = "export default __webpack_public_path__ + &quot;2390c3b98d57324a4c6acd2bfe2dcdc3.svg&quot;;"